<template>
  <Content>
    <template v-slot:topbar>
      <AddBank />
    </template>

    <template v-slot:content>
      <template v-if="banks && banks.data.length > 0">
        <div class="sm:rounded-md mb-3">
          <ul role="list" class="">
            <template v-for="item in banks.data" :key="item.id">
              <SingleBank :item="item" />
            </template>
          </ul>
        </div>

        <Pagination :meta="banks.meta" :onPageChange="onPageChange" />
      </template>

      <template v-else>
          <p class="py-6 text-center dark:text-gray-300">
            Diemžēl nekas netika atrasts
          </p>
      </template>
    </template>
  </Content>
</template>

<script>
import { debounce } from 'vue-debounce'
import {mapGetters} from "vuex";
import Search from "@/services/Helpers/search";
import AddBank from "@/components/Settings/CompanySettings/Banks/AddBank";
import SingleBank from "@/components/Settings/CompanySettings/Banks/SingleBank";
import Pagination from "@/components/Components/Pagination";

export default {
  name: "Banks",
  components: {
    AddBank,
    SingleBank,
    Pagination,
  },
  created() {
    this.$store.dispatch("setDataLoading", true)
  },
  mounted() {
    this.$store.dispatch('removeAllFormsForDisplay')
    this.$store.dispatch('resetSearch')
    const s = Search.getSearchQuery();
    if (s) {
      this.$store.dispatch('changeSearch', s)
      this.searchBanks()
    } else {
      this.$store.dispatch('getBanks', Search.getCurrentPage())
    }
  },
  computed: {
    ...mapGetters({
      banks: 'banks',
      formsForDisplay: 'formsForDisplay',
      editableItem: 'editableItem',
      search: 'search',
    })
  },
  watch: {
    search: function () {
      this.searchBanks()
    }
  },
  methods: {
    searchBanks: debounce(function () {
      this.$store.dispatch('changeSearch', this.search)
      this.$store.dispatch('getBanks', Search.getCurrentPage())
    }, 500),
    onPageChange(page) {
      this.$store.dispatch('getBanks', page);
      Search.changePage(this.banks.meta.current_page)
    },
    showForm(formName){
      this.$store.dispatch('addFormForDisplay', formName)
    },
    displayForm(formName){
      return this.formsForDisplay.includes(formName)
    },
    hideAddBankForm(){
      this.$store.dispatch('removeAllFormsForDisplay')
    },
  }
}
</script>